const USER_STORAGE_KEY = "user";
const SESSION_EXPIRED_MESSAGE = "Session expired. Please log in again.";

const isBrowser = () =>
  typeof window !== "undefined" && typeof window.location !== "undefined";

const getCurrentRedirectPath = () => {
  if (!isBrowser()) return "/";
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};

const isSignUpPath = () => {
  if (!isBrowser()) return false;
  return window.location.pathname === "/signUp";
};

export const isAuthFailureDetail = (detail) => {
  if (typeof detail !== "string") return false;
  const normalized = detail.toLowerCase();
  return (
    normalized.includes("token expired") ||
    normalized.includes("expired token") ||
    normalized.includes("session expired")
  );
};

export const isAuthFailureResponse = (status, detail) =>
  status === 401 || status === 403 || isAuthFailureDetail(detail);

export const handleAuthFailure = () => {
  if (!isBrowser()) return;
  if (window.__stocaiHandlingAuthFailure) return;

  window.__stocaiHandlingAuthFailure = true;

  try {
    window.localStorage.removeItem(USER_STORAGE_KEY);
  } catch {
    // Ignore storage failures; redirecting is still the correct recovery path.
  }

  if (isSignUpPath()) return;

  const redirect = encodeURIComponent(getCurrentRedirectPath());
  window.location.assign(`/signUp?redirect=${redirect}&session=expired`);
};

export { SESSION_EXPIRED_MESSAGE };
